<template>
  <div class="flex flex-col gap-2 md:min-w-[10rem]">
    <span>{{ t(`${trPrefix}addSuccess`, { wishlistName }) }}</span>
    <WebccButton class="w-fit" variant="theme" outline @click="edit()">
      <span>{{ t(`${trPrefix}change`) }}</span>
    </WebccButton>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  wishlistName: string
  accomCode: string
}>()

const trPrefix = 'www.components.views.search.area.wishlistModal.'

const { t } = useI18n()
const { edit } = useWishlistItemToggle(() => ({ code: props.accomCode }))
</script>
